import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'
import { IsEmail } from 'main/common/validation/decorators/IsEmail'
import { NotContainsSpace } from 'main/common/validation/decorators/NotContainsSpace'
import { IsString } from 'main/common/validation/decorators/IsString'
import { FormModel } from 'main/common/form-state-manager/FormModel'

/**
 * VALIDADOR
 * Define validacao dos campos do formulario de RECUPERAR SENHA.
 */
export class RecoverPwdFormValidator extends FormModel {

    @NotContainsSpace()
    @IsString()
    @IsNotEmpty()
    schema: string

    @IsEmail()
    @IsNotEmpty()
    email: string

    constructor(initialValues?: Partial<RecoverPwdFormValidator>) {
        super()
        Object.assign(this, initialValues)
    }
}
